<div style="display: flex; flex-direction: column; height: 100%; background-color: #4747475e;">
  <div style="display:flex; flex-direction: row; justify-content: center;
  align-items: center; height: 32px; background: #2E2E2E; box-shadow: 1px 1px 3px 2px #242424de;">
    <div>
      <input [(ngModel)]="currentPageNumber" (keydown.enter)="goToPage()" /> / {{pageCount}}
    </div>
    <div style="min-width:50px"></div>
    <div style="display:flex; flex-direction: row; align-items: center;">
      <lex-icon-button [icon]="'fa-duotone fa-magnifying-glass-minus'" [background]="'none'" [type]="'action'" (click)="zoomOut()"></lex-icon-button>
      <input [(ngModel)]="zoom" (change)="updateZoom()"/>%
      <lex-icon-button [icon]="'fa-duotone fa-magnifying-glass-plus'" [background]="'none'" [type]="'action'" (click)="zoomIn()"></lex-icon-button>
    </div>
  </div>
  <div #scrollContainer
    style="flex: 1; display: flex; justify-content: center; align-items: flex-start; overflow-y: auto; margin-top: 4px; padding: 3px;">
    <div #pdfContainer style="position: relative;"></div>
  </div>
</div>
